module.exports = __webpack_public_path__ + "img/mastercard-horizontal.9d40dcac.png";